import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { isMimeTypeCsv } from '../../../../helpers'
import { bulkUploadItemsCsv } from '../api/bulkUploadItemsCsv'

const isCsv = (f: File) => {
  const isCorrectExtension = f.name.toLowerCase().endsWith('.csv')
  const isCorrectFileType = f.type === '' || isMimeTypeCsv(f.type)

  return isCorrectExtension && isCorrectFileType
}

const validateOrThrowError = (f: File) => {
  if (!isCsv(f)) throw new Error('Invalid CSV')
  if (f.size === 0) throw new Error('Empty file')
  // TODO: max file size?
}

const uploadCsv = async (consignmentId: number, f: File) => {
  validateOrThrowError(f)

  const form = new FormData()
  form.append('file', f)

  return await bulkUploadItemsCsv(consignmentId, form)
}

function useConsignmentItemsUpload(consignmentId: number) {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (file: File) => uploadCsv(consignmentId, file),
    onSuccess: async () => {
      await queryClient.invalidateQueries(QueryKeys.houseConsignment.all(consignmentId))
      await queryClient.invalidateQueries(QueryKeys.consignment.summary(consignmentId))
    },
  })

  const { mutateAsync, isLoading } = mutation

  const upload = (file: File) => mutateAsync(file)

  return {
    upload,
    isUploading: isLoading,
  }
}

export default useConsignmentItemsUpload
